const css = `._3uJx7q__gradient{color:var(--special-intelligence-text-default);border:1px solid var(--base-strokes-default);background:linear-gradient(90deg,#1f8aff33 25%,#a340f233 75%),#fff}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"gradient":"_3uJx7q__gradient"};
